import React, { useRef, useContext, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useModal } from "../contexts/ModalContext";

import { getStorage, ref, uploadBytes } from "firebase/storage";

import { FileContext } from "./Dashboard";

import request from "request";

export default function FileImport() {
  const { currentUser } = useAuth();
  const { modalDispatch } = useModal();

  const {
    selectedFile,
    setSelectedFile,
    setIsSelected,
    // setReportExists,
    // setReportData,
    change,
    setChange,
    loading,
    setLoading,
  } = useContext(FileContext);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const dateRef = useRef();
  const timeRef = useRef();
  const instrumentRef = useRef();
  const symbolRef = useRef();
  const sideRef = useRef();
  const priceRef = useRef();
  const quantityRef = useRef();

  const handleCancel = () => {
    setSelectedFile("");
    setIsSelected(false);
    modalDispatch({ type: "SHOW_ERROR", payload: "File import canceled" });
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    const timestamp = new Date().getTime();
    try {
      const storage = getStorage();
      const storageRef = ref(
        storage,
        `users/${currentUser.uid}/trades_${currentUser.uid}_${timestamp}.csv`
      );
      const metadata = {
        customMetadata: {
          dateColumn: dateRef.current.value,
          timeColumn: timeRef.current.value,
          instrumentColumn: instrumentRef.current.value,
          symbolColumn: symbolRef.current.value,
          sideColumn: sideRef.current.value,
          priceColumn: priceRef.current.value,
          quantityColumn: quantityRef.current.value,
        },
      };
      uploadBytes(storageRef, selectedFile, metadata)
        .then(() => {
          try {
            currentUser
              .getIdToken(true)
              .then(function (idToken) {
                // console.log(idToken);
                // console.log(timestamp);
                // const tradeFileRef = doc(
                //   db,
                //   `users/${currentUser.uid}/trade_imports`,
                //   `trades_${timestamp}`
                // );
                // setDoc(tradeFileRef, { timestamp: timestamp })
                //   .then(() => {
                var options = {
                  url: `https://dee14121.us-south.apigw.appdomain.cloud/bejour-api/action?idToken=${idToken}&timestamp=${timestamp}`,
                  // headers: {
                  //   Authorization: "Bearer",
                  // },
                  json: true,
                };

                request.get(options, function (error, response, body) {
                  if (!error && response.statusCode === 200) {
                    if (!body.error_message) {
                      // let docSnapData = { disposition_effect: "N/A", overconfidence: "N/A" };
                      // docSnapData.disposition_effect = body.return_body.disposition_effect;
                      // docSnapData.overconfidence = body.return_body.overconfidence;
                      // setReportData(docSnapData);
                      // setReportExists(true);
                      setChange(!change);
                      setLoading(false);
                      modalDispatch({
                        type: "SHOW_SUCCESS",
                        payload: "Successfully imported data",
                      });
                      return setIsSelected(false);
                    } else {
                      setLoading(false);
                      modalDispatch({
                        type: "SHOW_ERROR",
                        payload: "Import failed, error: " + body.error_message,
                      });

                      return setIsSelected(false);
                    }
                  } else {
                    setLoading(false);
                    modalDispatch({
                      type: "SHOW_ERROR",
                      payload: "Request to the analysis function failed, error: " + error,
                    });
                    return setIsSelected(false);
                  }
                });
                // })
                // .catch((err) => {
                //   setLoading(false);
                //   setShowModal(true);
                //   setModalText(
                //     "Could not find a reference to the trade file, error: " +
                //       err
                //   );
                //   return setIsSelected(false);
                // });
              })
              .catch((err) => {
                setLoading(false);
                modalDispatch({
                  type: "SHOW_ERROR",
                  payload: "Could not identify user, error: " + err,
                });
                return setIsSelected(false);
              });
          } catch (err) {
            setLoading(false);
            modalDispatch({
              type: "SHOW_ERROR",
              payload: "Could not upload file, please try again; error: " + err,
            });

            return setIsSelected(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          modalDispatch({
            type: "SHOW_ERROR",
            payload: "Could not upload file, please try again; error: " + err,
          });
          return setIsSelected(false);
        });
    } catch (err) {
      setLoading(false);
      modalDispatch({
        type: "SHOW_ERROR",
        payload: "Could not upload file, please try again; error: " + err,
      });
      return setIsSelected(false);
    }
  }

  return (
    <>
      {!loading ? (
        <>
          <section className="file-import-section">
            <div className="file-import-background"></div>
            <div className="flex-column file-import-window">
              {/* <h2 className="file-import-header">Help us import your data</h2> */}
              <h2 className="file-import-subheader">
                Please specficy the respective column number or letter (A-Z) for the following
                variables:
              </h2>
              <form className="file-import-form" onSubmit={handleSubmit}>
                <div className="file-import-side left flex-column">
                  <div className="import-variable">
                    <div className="import-variable-info">
                      <label className="import-label" htmlFor="date">
                        Date
                      </label>
                      <div className="import-add-info">usual date formats</div>
                    </div>

                    <input
                      className="import-input"
                      type="text"
                      name="date"
                      id="date"
                      ref={dateRef}
                      required
                    />
                  </div>
                  <div className="import-variable">
                    <div className="import-variable-info">
                      <label className="import-label" htmlFor="time">
                        Time
                      </label>
                      <div className="import-add-info">can be in DATE</div>
                    </div>

                    <input
                      className="import-input"
                      type="text"
                      name="time"
                      id="time"
                      ref={timeRef}
                    />
                  </div>

                  <div className="import-variable">
                    <div className="import-variable-info">
                      <label className="import-label" htmlFor="instrument">
                        Instrument
                      </label>
                      <div className="import-add-info">value e.g. STOCK</div>
                    </div>

                    <input
                      className="import-input"
                      type="text"
                      name="instrument"
                      id="instrument"
                      ref={instrumentRef}
                      required
                    />
                  </div>
                  <div className="import-variable">
                    <div className="import-variable-info">
                      <label className="import-label" htmlFor="symbol">
                        Symbol
                      </label>
                      <div className="import-add-info">ticker symbol</div>
                    </div>

                    <input
                      className="import-input"
                      type="text"
                      name="symbol"
                      id="symbol"
                      ref={symbolRef}
                      required
                    />
                  </div>
                </div>
                <div className="file-import-seperator"> </div>
                <div className="file-import-side flex-column">
                  <div className=" import-variable">
                    <div className="import-variable-info">
                      <label className="import-label" htmlFor="side">
                        Side
                      </label>
                      <div className="import-add-info">BUY or SELL</div>
                    </div>

                    <input
                      className="import-input"
                      type="text"
                      name="side"
                      id="side"
                      ref={sideRef}
                      required
                    />
                  </div>
                  <div className="import-variable">
                    <div className="import-variable-info">
                      <label className="import-label" htmlFor="price">
                        Price
                      </label>
                      <div className="import-add-info">in USD</div>
                    </div>

                    <input
                      className="import-input"
                      type="text"
                      name="price"
                      id="price"
                      ref={priceRef}
                      required
                    />
                  </div>
                  <div className=" import-variable">
                    <div className="import-variable-info">
                      <label className="import-label" htmlFor="quantity">
                        Quantity
                      </label>
                      <div className="import-add-info">trade quantity</div>
                    </div>

                    <input
                      className="import-input"
                      type="text"
                      name="quantity"
                      id="quantity"
                      ref={quantityRef}
                      required
                    />
                  </div>
                  <div className=" import-btn-container">
                    <button type="submit" className="btn  flex-align-self-right">
                      Submit
                    </button>

                    <button className="btn btn-sec" onClick={handleCancel}>
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </section>
        </>
      ) : null}
    </>
  );
}
